import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal'

@Component({
  selector: 'vss-ui-link-list',
  templateUrl: './link-list.component.html',
  styleUrls: ['./link-list.component.scss']
})
export class LinkListComponent implements OnInit {
  needDelete = false

  listData: any[] = []

  constructor(
    private modalRef: NzModalRef,
  ) { }

  ngOnInit(): void {
  }

  openLink(item: any): void {
    const link = item.fileUrl;
    if (link) {
      window.open(link)
      return
    }

    var a = document.createElement('a');
    var file = new Blob([item.file]);
    a.href = URL.createObjectURL(file);
    a.download = item.file?.name;
    a.click();


  }

  deleteFile(item: any): void {
    // const rowData = this.listOfData.find(v => v.id === item.id)
    // rowData.attachFiles = rowData.attachFiles.filter((v: any) => v.id !== item.attachFiles[0].id )
    this.listData = this.listData.filter((v: any) => v.id !== item.id )

  }

  closeModal() {
    this.modalRef.close()
  }

  submit() {
    this.modalRef.close(this.listData)
  }
}
